// extracted by mini-css-extract-plugin
export var border__top = "FooterMobile-module--border__top--d247c";
export var column__container = "FooterMobile-module--column__container--4b9f7";
export var column__content = "FooterMobile-module--column__content--7dc45";
export var container_form = "FooterMobile-module--container_form--c1742";
export var copyright = "FooterMobile-module--copyright--38c20";
export var copyright__container = "FooterMobile-module--copyright__container--9b7de";
export var divider = "FooterMobile-module--divider--d6ef7";
export var dividerVertical = "FooterMobile-module--dividerVertical--e972f";
export var finalrow__container = "FooterMobile-module--finalrow__container--f1041";
export var finalrow__content = "FooterMobile-module--finalrow__content--8391b";
export var form = "FooterMobile-module--form--b412f";
export var links = "FooterMobile-module--links--b7100";
export var list = "FooterMobile-module--list--5c6ca";
export var main__container = "FooterMobile-module--main__container--1b352";
export var newsletter__button = "FooterMobile-module--newsletter__button--61717";
export var newsletter__container = "FooterMobile-module--newsletter__container--532d1";
export var newsletter__input = "FooterMobile-module--newsletter__input--cacb0";